import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { mobileMenuOpen } from '../constants/initial-state';

export default function menuReducer(state = mobileMenuOpen, action: IAction) {
    switch (action.type) {
        case types.OPEN_MOBILE_MENU:
            return true;
        case types.CLOSE_MOBILE_MENU:
            return false;
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/menu.reducer.ts